import { useMemo } from 'react';
import { TIcon } from './types';

export function getBreakpoints(blockWidth: number) {
  return Array(Math.floor(4000 / blockWidth))
    .fill(1)
    .map((_, i) => (i + 1) * blockWidth);
}

export function useStyles({
  containerWidth,
  iconWidth,
  breakPoint,
  verticalGap,
  removeHorizontalPadding,
}: {
  containerWidth: number;
  iconWidth: number;
  breakPoint: number;
  verticalGap?: number;
  removeHorizontalPadding?: boolean;
}) {
  const gap =
    (containerWidth - iconWidth * breakPoint) /
    (breakPoint + (removeHorizontalPadding ? -1 : 1));
  const sx = useMemo(
    () => ({
      justifyContent: 'space-evenly',
      gridTemplateColumns: `repeat(${breakPoint}, 1fr)`,
      rowGap: verticalGap ?? 0,
      columnGap: `${gap}px`,
      px: removeHorizontalPadding ? 0 : `${gap}px`,
    }),
    [removeHorizontalPadding, breakPoint, gap, verticalGap],
  );

  return sx;
}

export const justToFillTheRow = 'JUST TO FILL THE ROW';

export function getRowIcons<P>({
  breakPoint,
  icons,
  i,
}: {
  breakPoint: number;
  icons: TIcon<P>[];
  i: number;
}) {
  const actualIcons: (string | TIcon<P>)[] = icons.slice(
    i * breakPoint,
    (i + 1) * breakPoint,
  );
  if (actualIcons.length < breakPoint)
    actualIcons.push(
      ...(Array(breakPoint - actualIcons.length).fill(
        justToFillTheRow,
      ) as string[]),
    );

  return actualIcons;
}
